import styled from 'styled-components';
import Title from '$app/apps/bookings/components/Title';
import Card from '$app/components/vendor/Card';

export const HeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const LeftSide = styled.div`
  display: flex;
  align-items: center;
`;

export const RightSide = styled.div`
  display: flex;
  margin-left: auto;
`;

export const TitleStyled = styled(Title)`
  margin: 0 15px 0 0;
`;

export const Container = styled(Card)`
  margin-bottom: 0;
`;